import React from 'react';
import { Tabs } from 'antd';

import { IStoneGroup } from '../../../../sharedInterfaces';
import { StyledArrow, OptionsContainer, SectionTitle } from './Stones-styled';
import { TabSelect, isMobile, isLowHeight, StoneSizeSlider } from '../../ui-helpers';
import { ITabSelectTab } from '../../ui-helpers/TabSelect/TabSelect';

import {
  Slider,
  Dropdown,
} from '../../ui-helpers';

import {
  Image,
  OptionItem,
  SliderTitle,
  StoneConfigs,
  SliderContainer
} from './Stones-styled';
import { MenuSection } from '../Materials/Materials-styled';
import { isVeryLowHeight } from '../../../shared/UIHelpers/Functions/Functions';


const { TabPane } = Tabs;

interface IOptionProps {
  option:string,
  assetURI:string,
  isSelected:boolean,
  onClick:(value:any)=>void,
}

const Option:React.FunctionComponent<IOptionProps> = (props) => {
  const { option, assetURI, isSelected, onClick } = props;

  return (
    <OptionItem
      onClick={() => onClick(option)}
    >
      <Image
        width={52}
        height={52}
        src={`${assetURI}/images/stones/${option}.png`}
        showBorder={isSelected}
        borderWidth={3}
      />
      {option}
    </OptionItem>
  )
}


interface Props {
  stoneCut:'Brilliant'|'Princess'|'Baguette',

  stoneCount:number,
  stoneCountOptions:number[],
  onStoneCountChange:(value:number)=>void

  stoneSize:number,
  stoneSizeOptions:number[],
  onStoneSizeChange:(value:number)=>void,

  stoneGroups:IStoneGroup[],
  onStoneGroupChange:(value:IStoneGroup)=>void,

  currentMenuStoneGroup:IStoneGroup,
  onCurrentMenuStoneGroupChange:(setTo:string)=>void,

  scrolling:boolean,
  assetURI:string
}

export default class extends React.Component<Props,{}> {
  constructor(props:Props) {
    super(props);
  };// /constructor()

  onParameterChange = (group:string, param:any, value:any) => {
    const { stoneGroups } = this.props;
    const editedStoneGroup = stoneGroups.find(({ name }) => name === group);

    this.props.onStoneGroupChange({
      ...editedStoneGroup,
      [param]: value,
    });
  };

  render = () => {
    const {
      stoneCount,
      stoneCountOptions,
      onStoneCountChange,
      stoneSize,
      stoneSizeOptions,
      onStoneSizeChange,
      stoneGroups,
      currentMenuStoneGroup,
      onCurrentMenuStoneGroupChange,
      scrolling,
      assetURI
    } = this.props;
    const mobile = isMobile();
    const lowHeight = isLowHeight();

    const stoneType = this.props.currentMenuStoneGroup ? this.props.currentMenuStoneGroup.stone : null;

    return (
      <div className="threed-configurator-menu-stones-tab">
        <StoneConfigs>
          <Dropdown
            title="Count"
            titleFontWeight={700}
            width={100}
            opacity={1}
            defaultOption={stoneCount}
            options={stoneCountOptions}
            onChange={onStoneCountChange}
            disabled={stoneCountOptions.length <= 1}
          />

          <SliderContainer className="threed-configurator-slider-container"
            disabled={stoneCount === 0 || stoneSizeOptions.length <= 1}
          >
            <SliderTitle>Size</SliderTitle>
            <StoneSizeSlider
              defaultValue={stoneSize}
              options={stoneSizeOptions}
              onChange={onStoneSizeChange}
              disabled={stoneCount === 0 || stoneSizeOptions.length <= 1}
              tooltipVisible={!scrolling}
              stoneType={stoneType}
              stoneCut={this.props.stoneCut}
            />
          </SliderContainer>
        </StoneConfigs>

        <MenuSection className="threed-configurator-menu-section"
          style={{
            marginBottom: `${mobile ? '5px' : 'unset'}`
          }}
        >
          {(currentMenuStoneGroup && stoneGroups.length > 1) &&
            <TabSelect className="threed-configurator-menu-stone-group-select"
              tabs={stoneGroups.map((stoneGroup) => {
                const tab:ITabSelectTab = {
                  title: stoneGroup.name,
                  subTitle: `${stoneGroup.stone || ''}`,
                  isActive: (stoneGroup.name === currentMenuStoneGroup.name),
                  onClick: () => onCurrentMenuStoneGroupChange(stoneGroup.name)
                }
                return tab;
              })}
            />
          }

          {(currentMenuStoneGroup && currentMenuStoneGroup.stoneOptions.length > 0) && <SectionTitle>Choose Stone</SectionTitle>}
          <OptionsContainer>
            {(currentMenuStoneGroup && currentMenuStoneGroup.stoneOptions.length > 0) && currentMenuStoneGroup.stoneOptions.map(option =>
              <Option
                option={option}
                assetURI={assetURI}
                isSelected={option === currentMenuStoneGroup.stone}
                onClick={(value) => this.onParameterChange(currentMenuStoneGroup.name, 'stone', value)}
                key={`${name}-stone-${option.toLowerCase().replace(' ', '-')}`}
              />
            )}
          </OptionsContainer>
        </MenuSection>

        {(!lowHeight) &&
          <MenuSection className="threed-configurator-menu-section" style={{ height: '25%' }}>
          {/* This element only exists to keep its siblings aligned correctly */}
          </MenuSection>
        }

      </div>
    );
  };// /render()
};// /class
